import { render, staticRenderFns } from "./activitySelection.vue?vue&type=template&id=2bf64173&scoped=true&"
import script from "./activitySelection.vue?vue&type=script&lang=js&"
export * from "./activitySelection.vue?vue&type=script&lang=js&"
import style0 from "./activitySelection.vue?vue&type=style&index=0&id=2bf64173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf64173",
  null
  
)

export default component.exports